"use client";

import { useEffect, useRef } from "react";
import Script from "next/script";

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

/**
 * The AdSense tag and one in-article unit. The tag is loaded only on pages that
 * carry a unit, so booking pages never load AdSense at all (next/script loads
 * it once however many units a page has). Google's own consent message, set up
 * in AdSense under Privacy & messaging, is served by this same tag.
 */
export function AdUnit({ client, slot }: { client: string; slot: string }) {
  const ref = useRef<HTMLModElement>(null);
  useEffect(() => {
    // A unit that already holds an ad (back/forward cache) must not be filled twice.
    if (!ref.current || ref.current.dataset.adsbygoogleStatus) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // Blocked by an ad blocker or not ready: the reserved space stays empty.
    }
  }, []);
  return (
    <>
      <Script
        id="adsbygoogle-js"
        strategy="afterInteractive"
        crossOrigin="anonymous"
        src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`}
      />
      <ins
        ref={ref}
        className="adsbygoogle block min-h-[250px]"
        style={{ display: "block", textAlign: "center" }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-layout="in-article"
        data-ad-format="fluid"
      />
    </>
  );
}
